import { Box, Breakpoint } from "@mui/material";
import React from "react";

interface IProps extends React.PropsWithChildren {
    maxWidth?: Breakpoint;
}
export const MprcContainerViewPort = ({ maxWidth = "md", children }: IProps) => {
    return (
        <Box sx={theme => ({ maxWidth: theme.breakpoints.values[maxWidth], margin: "0 auto" })}>
            {children}
        </Box>
    );
};